import React from 'react';

/**
 * React 19 native metadata hoisting.
 * <title>, <meta>, <link> are auto-hoisted to <head>.
 * <script type="application/ld+json"> is read by crawlers in body or head.
 */
const SEO = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  canonicalUrl,
  structuredData,
}) => {
  const siteUrl = 'https://upscale.no';
  const defaultImage = `${siteUrl}/og-image.png`;
  const url = canonicalUrl || siteUrl;
  const image = ogImage || defaultImage;

  return (
    <>
      {/* Primary */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Upscale" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={ogTitle || title} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@upscale_no" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={ogTitle || title} />

      {/* Canonical & misc */}
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1"
      />
      <meta name="language" content="English" />
      <meta name="author" content="Upscale Growth AS" />
      <meta name="geo.region" content="NO" />
      <meta name="geo.placename" content="Oslo" />

      {/* JSON-LD structured data — valid anywhere in document per Google */}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}
    </>
  );
};

export default SEO;
